if (!customElements.get('speech-search-button')) {
  customElements.define(
    'speech-search-button',
    class SpeechSearchButton extends HTMLElement {
      constructor() {
        super();
        this.recognition = null;
        this.isListening = false;
        this.form = null;
        this.searchInput = null;
      }
    
      connectedCallback() {
        if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
          const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
          this.recognition = new SpeechRecognition();
          this.recognition.continuous = false;
          this.recognition.interimResults = false;
    
          const language = this.getAttribute('data-language') || navigator.language || 'en-US';
          this.recognition.lang = language;
    
          this.form = this.closest('form');
          this.searchInput = this.form.querySelector('.search__input');
    
          this._bindEvents();
        }
      }
    
      _bindEvents() {
        this.addEventListener('click', (e) => this.toggleListen(e));

        this.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { 
            e.preventDefault();
            this.toggleListen(e); 
          }
        });
    
        this.recognition.addEventListener('result', (event) => {
          const transcript = event.results[0][0].transcript;
          this.searchInput.value = transcript;
    
          const predictiveSearch = this.closest('predictive-search');
        
          if (predictiveSearch) {
            const predictiveSearchInput = predictiveSearch.querySelector('.search__input');
            predictiveSearchInput.value = transcript;
    
            const inputEvent = new Event('input');
            predictiveSearchInput.dispatchEvent(inputEvent);
          } else {
            this.form.submit();
          }
        });
    
        this.recognition.addEventListener('audiostart', () => {
          this.isListening = true;
          this.classList.add('search__speech-listening');
        });
    
        this.recognition.addEventListener('audioend', () => {
          this.isListening = false;
          this.classList.remove('search__speech-listening');
        });
      }
    
      toggleListen(event) {
        event.preventDefault();
        if (this.isListening) {
          this.recognition.stop();
        } else {
          this.recognition.start();
        }
      }
    }
  );
}